import * as React from 'react';
import { Link } from 'react-router-dom';
import { APP_NAME } from '../Const';
import './PageHeader.css';

export interface PageHeaderBreadcrumb {
  label: string;
  /** 遷移先のパス。指定したときはreact-routerのLinkで表示する */
  to?: string;
}

interface PageHeaderProps {
  title: string;
  /** 上位の画面から現在地までの並び。最後の要素は現在地として、toがあってもリンクにしない */
  breadcrumbs?: PageHeaderBreadcrumb[];
  /** 見出しの行の右端に並べるボタン */
  actions?: React.ReactNode;
}

const PageHeaderBreadcrumbItem: React.FC<{ item: PageHeaderBreadcrumb; current: boolean }> = function (
  props
) {
  if (props.current) {
    return (
      <span className="PageHeader-breadcrumb_current" aria-current="page">
        {props.item.label}
      </span>
    );
  }

  if (props.item.to) {
    return (
      <Link className="PageHeader-breadcrumb_link" to={props.item.to}>
        {props.item.label}
      </Link>
    );
  }

  return <span>{props.item.label}</span>;
};

/**
 * 画面の見出し。パンくずリストを上に、その下にh1と右端のボタン群を同じ行に並べる。
 * 表示している間、ブラウザのタブの表示名を「{title} | システム名」にする。
 */
export const PageHeader: React.FC<PageHeaderProps> = function (props) {
  React.useEffect(() => {
    const previousTitle = document.title;
    document.title = `${props.title} | ${APP_NAME}`;
    return () => {
      document.title = previousTitle;
    };
  }, [props.title]);

  return (
    <div className="PageHeader">
      {(() => {
        if (!props.breadcrumbs || props.breadcrumbs.length === 0) {
          return null;
        }
        const lastIndex = props.breadcrumbs.length - 1;
        return (
          <nav className="PageHeader-breadcrumbs" aria-label="パンくずリスト">
            <ol className="PageHeader-breadcrumb_list">
              {props.breadcrumbs.map((item, index) => (
                <li className="PageHeader-breadcrumb_item" key={index}>
                  {(() => {
                    if (index === 0) {
                      return null;
                    }
                    return (
                      <span className="PageHeader-breadcrumb_separator" aria-hidden="true">
                        {' / '}
                      </span>
                    );
                  })()}
                  <PageHeaderBreadcrumbItem item={item} current={index === lastIndex} />
                </li>
              ))}
            </ol>
          </nav>
        );
      })()}
      <div className="PageHeader-title_row">
        <h1 className="PageHeader-title">{props.title}</h1>
        {(() => {
          if (!props.actions) {
            return null;
          }
          return <div className="PageHeader-actions">{props.actions}</div>;
        })()}
      </div>
    </div>
  );
};
